import gql from 'graphql-tag';

export const GET_CUSTOMER_OPPORTUNITIES = gql`
  query GetCustomerOpportunities($customerAccountId: ID!) {
    customer {
      customerOpportunities(customerAccountId: $customerAccountId) {
        error
        success
        list {
          vendorOpportunityId
          invoiceTotal
          transactionStage
          createdDateTime

          salesRepresentative {
            fullName
          }
        }
      }
    }
  }
`;
